import React, { Fragment } from 'react';
import Breadcrumbs from '../../../CommonComponents/Breadcrumbs/Breadcrumbs';

import { MAIN_ICONS, CONCEPT, FEATURES, LINEUP_NAV } from './constants';
import './HeaderJunni.scss';

export const HeaderJunni = ({ baseImgUrl }) => {
  const title = 'Junni（Kids Glasses）';
  const breadcrumbs = [
    { path: '/sg/en', label: 'Homepage' },
    { path: '/sg/en/news', label: 'News' },
    { path: '#', label: title },
  ];

  const scrollToSection = id => {
    if (!id) return;

    const elementId = id.startsWith('#') ? id.substring(1) : id;
    const element = document.getElementById(elementId);

    window.location.hash = elementId;

    if (element) {
      const headerHeight = document.querySelector('header')?.offsetHeight || 0;
      let headerOffset = 0;

      if (window.innerWidth <= 767) {
        headerOffset = headerHeight - 140;
      } else {
        headerOffset = headerHeight + 50;
      }

      const elementTop = element.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementTop - headerOffset,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Fragment>
      <Breadcrumbs crumbs={breadcrumbs} />

      <section className="header-junni__main">
        <h1 className="header-junni__main__logo">
          <span>{title}</span>
          <img alt={title} src={`${baseImgUrl}/main/junni_logo.svg`} />
        </h1>

        <div className="header-junni__main__bg">
          <picture>
            <source media="(min-width: 768px)" srcSet={`${baseImgUrl}/main/main_pc.webp`} />
            <img alt={title} src={`${baseImgUrl}/main/main_sp.webp`} />
          </picture>
        </div>

        <div className="header-junni__main__icons">
          <div className="header-junni__main__icons__inner">
            {MAIN_ICONS.map(({ name, alt }) => (
              <img
                key={name}
                alt={alt}
                className={`header-junni__main__icon__${name}`}
                src={`${baseImgUrl}/main/${name}-icon.svg`}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="header-junni__concept">
        <div className="header-junni__concept__container">
          <picture>
            <source media="(min-width: 768px)" srcSet={`${baseImgUrl}/concept/concept_pc.webp`} />
            <img alt={title} src={`${baseImgUrl}/concept/concept_sp.webp`} />
          </picture>

          <div className="header-junni__concept__content">
            <h2 className="header-junni__concept__content__title">{CONCEPT.title}</h2>

            <p className="header-junni__concept__content__desc">{CONCEPT.desc}</p>

            <a className="base-junni__btn" href={CONCEPT.button.link}>
              <span>{CONCEPT.button.label}</span>
            </a>
          </div>
        </div>
      </section>

      <section className="header-junni__features">
        <div className="header-junni__features__sticker header-junni__features__sticker--top">
          <img
            alt={title}
            className="bg"
            loading="lazy"
            src={`${baseImgUrl}/sticker-features-top-1.svg`}
          />
          <img
            alt={title}
            className="fg"
            loading="lazy"
            src={`${baseImgUrl}/sticker-features-top-2.svg`}
          />
        </div>
        <img
          alt={title}
          className="header-junni__features__sticker header-junni__features__sticker--bottom"
          loading="lazy"
          src={`${baseImgUrl}/sticker-features-bottom.svg`}
        />
        <div className="header-junni__features__container">
          <h2 className="header-junni__features__title">
            <span>{FEATURES.title}</span>
            <small>{FEATURES.subTitle}</small>
          </h2>

          <ul className="header-junni__features__list">
            {FEATURES.list.map(({ title, alt }, i) => (
              <li key={alt}>
                <img
                  alt={alt}
                  loading="lazy"
                  src={`${baseImgUrl}/features/features-${i + 1}.svg`}
                />
                <p>{title}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="header-junni__lineup-nav">
        <div className="header-junni__lineup-nav__container">
          <h2 className="header-junni__lineup-nav__title">{LINEUP_NAV.title}</h2>

          <ul className="header-junni__lineup-nav__list">
            {LINEUP_NAV.list.map(({ title, alt, img }) => (
              <li
                key={alt}
                onClick={() => scrollToSection(`${title.toLowerCase().replace(' ', '-')}`)}
              >
                <img alt={alt} loading="lazy" src={`${baseImgUrl}${img}`} />
                <p>{title}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </Fragment>
  );
};
